namespace $.$$ {

	export class $shm_hitalama_map_widget_float_settings_tabulator extends $.$shm_hitalama_map_widget_float_settings_tabulator {

		@ $mol_mem
		table() {
			return this.controlled_widget().table()!
		}

		headers_text( next?: string ) {
			if( next === undefined ) return this.table().table_head().join( '\n' )

			const head = next
				.split( /\r?\n/ )
				.map( title => title.trim() )
				.filter( Boolean )

			this.table().table_head( head )
			return next
		}

		head_code( next?: string ) {
			return this.table().Head_method(next)?.val( next ) ?? ''
		}

		rows_code( next?: string ) {
			return this.table().Rows_method(next)?.val( next ) ?? ''
		}

		setting< Value >( name: string, next: Value | undefined, fallback: Value ): Value {
			const prev = ( this.controlled_widget().data() ?? {} ) as Record< string, Value >
			if( next === undefined ) return prev[ name ] ?? fallback

			this.controlled_widget().data({ ... prev, [ name ]: next })
			return next
		}

		layout( next?: string ) {
			return this.setting( 'layout', next, 'fitDataStretch' )
		}

		header_filter( next?: boolean ) {
			return this.setting( 'header_filter', next, false )
		}

		sortable( next?: boolean ) {
			return this.setting( 'sortable', next, true )
		}

		resizable_columns( next?: boolean ) {
			return this.setting( 'resizable_columns', next, false )
		}

		movable_columns( next?: boolean ) {
			return this.setting( 'movable_columns', next, false )
		}

		editable( next?: boolean ) {
			return this.setting( 'editable', next, false )
		}

		pagination( next?: boolean ) {
			return this.setting( 'pagination', next, false )
		}

		page_size( next?: number ) {
			return this.setting( 'page_size', next, 10 )
		}

		pagination_settings() {
			return this.pagination() ? super.pagination_settings() : []
		}

	}

}
